<section>
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-lg-8">
        @if (subtitle()) {
          <app-title [titles]="[subtitle()]" />
        }
        @if (title()) {
          <app-title [titles]="[title()]" class="title" />
        }
      </div>
      @if (breakpoints() === "desktop") {
        <div class="col-lg-4"></div>
      }
    </div>
    @if (data().items) {
      <ul class="items row">
        @for (item of items(); track item) {
          <li class="item col-xs-12 col-lg-4">
            <hr class="item-separator" />
            @if (item.title; as title) {
              <app-title [titles]="[title]" />
            }
            @if (item.text; as text) {
              <p [innerHTML]="text" class="paragraph"></p>
            }
          </li>
        }
      </ul>
    }
  </div>
</section>
